import BaseLink from 'component/base/Link';
import TextInputField, {
  TextInputFieldProps,
} from 'component/ui/FormFields/TextInput';
import { IconName } from 'enums/icon';
import React, { useCallback, useReducer } from 'react';

import { ShowHideButton } from './styles';

const actionEl = (
  <BaseLink to="/forgot-password" active>
    Reset password
  </BaseLink>
);

type State = {
  show: boolean;
  ariaLiveMessage: string;
};

type ReducerAction = {
  type: 'TOGGLE_SHOW';
};

const initialState: State = {
  show: false,
  ariaLiveMessage: '',
};

const reducer = (state: State, action: ReducerAction): State => {
  switch (action.type) {
    case 'TOGGLE_SHOW':
      return {
        ...state,
        show: !state.show,
        ariaLiveMessage: !state.show
          ? 'Password field icon has changed to hide password'
          : 'Password field icon has changed to show password',
      };
    default:
      return state;
  }
};

const PasswordInputField = (
  props: TextInputFieldProps & { showResetLink?: boolean },
) => {
  const { showResetLink = false } = props;
  const [state, dispatch] = useReducer(reducer, initialState);
  const { show, ariaLiveMessage } = state;

  const onClick = useCallback(() => {
    dispatch({ type: 'TOGGLE_SHOW' });
  }, []);

  const icon = (
    <ShowHideButton
      ariaLiveMessage={ariaLiveMessage}
      onClick={onClick}
      iconName={!show ? IconName.VIEW_1 : IconName.LAYERS_HIDE}
      iconThemeColor="steel"
      iconHeight="24px"
      iconWidth="24px"
      height="28px"
      width="28px"
      title={!show ? 'Show password' : 'Hide Password'}
      $show={show}
    />
  );
  const type = show ? 'text' : 'password';
  return (
    <TextInputField
      {...props}
      icon={icon}
      type={type}
      action={showResetLink ? actionEl : null}
    />
  );
};

export default PasswordInputField;
